import React, { useState } from 'react';

import { Route, Routes, useNavigate } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';
import AcceptPage from '@/features/invitations/components/AcceptConfirmPage';
import { Authenticated } from '@/routes/Routes';

import InvitationRegisterCompletePage from './InvitationRegisterCompletePage';
import InvitationRegisterConfirmPage from './InvitationRegisterConfirmPage';
import InvitationRegisterErrorPage from './InvitationRegisterErrorPage';
import { type InvitationRegisterFormValues } from './InvitationRegisterInputForm';
import InvitationRegisterInputPage from './InvitationRegisterInputPage';
import InvitationStudentConfirmPage from './InvitationStudentConfirmPage';

const InvitationRegistration: React.FC = () => {
  // パスワードを含むので router の state に載せない（history.state に残り、ブラウザが保存する）
  const [formValues, setFormValues] =
    useState<InvitationRegisterFormValues | null>(null);
  const navigate = useNavigate();

  const handleInputSubmit = (values: InvitationRegisterFormValues) => {
    setFormValues(values);
    navigate('/invitations/register/confirm');
  };

  const handleBack = () => {
    setFormValues(
      (prev) => prev && { ...prev, password: '', password_confirmation: '' },
    );
    navigate('/invitations/register/input');
  };

  const handleRegistered = () => {
    navigate('/invitations/register/complete');
    setFormValues(null);
  };

  const handleRegisterFailed = () => {
    navigate('/invitations/register/error');
    setFormValues(null);
  };

  return (
    <Routes>
      <Route path="/register" element={<InvitationStudentConfirmPage />} />
      <Route
        path="/register/input"
        element={
          <InvitationRegisterInputPage
            defaultFormValues={formValues}
            onSubmit={handleInputSubmit}
          />
        }
      />
      <Route
        path="/register/confirm"
        element={
          <InvitationRegisterConfirmPage
            formValues={formValues}
            onBack={handleBack}
            onRegistered={handleRegistered}
            onRegisterFailed={handleRegisterFailed}
          />
        }
      />
      <Route
        path="/register/complete"
        element={<InvitationRegisterCompletePage />}
      />
      <Route path="/register/error" element={<InvitationRegisterErrorPage />} />

      <Route element={<Authenticated />}>
        <Route path="accept/*" element={<AcceptPage />} />
      </Route>

      <Route path="*" element={<ErrorPage type="not_found" />} />
    </Routes>
  );
};

export default InvitationRegistration;
